



















































































































import Vue from 'vue';
import { Component, Prop, Ref } from 'vue-property-decorator';
import { EmoticonEntity } from '@/entities/emoticon.entity';
import { mapActions, mapGetters } from 'vuex';
import { DailyReportEntity } from '@/entities/daily-report.entity';
import { UseService } from '@/services/service';
import DailyReportService from '@/services/daily-report.service';
import { ValidationObserver } from 'vee-validate';
import { StaffEntity } from '@/entities/staff.entity';
import VueI18n from 'vue-i18n';
import { getFileNameFromPath } from '@/helper/file';
import TranslateResult = VueI18n.TranslateResult;

@Component<DialogDailyReport>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
    ...mapGetters('emoticon', ['emoticons']),
  },
  methods: {
    ...mapActions('emoticon', ['fetchEmoticons']),
  },
  watch: {
    value: {
      async handler() {
        if (this.currentStaff.dailyReport.length) {
          this.dailyReportPayload.content =
            this.currentStaff.dailyReport[0].content;
          this.dailyReportPayload.emoticonId =
            this.currentStaff.dailyReport[0].emoticonId;
        }
      },
    },
  },
})
export default class DialogDailyReport extends Vue {
  emoticons!: EmoticonEntity[];
  currentStaff!: StaffEntity;
  fetchEmoticons!: () => Promise<void>;
  file: File = null;
  dailyReportPayload: Partial<DailyReportEntity> = {
    content: null,
    emoticonId: null,
  };

  @UseService(DailyReportService)
  service: DailyReportService;

  @Prop({ type: Boolean })
  value: boolean;

  @Ref('form') form: InstanceType<typeof ValidationObserver>;

  get placeHolderInputFile(): TranslateResult {
    if (this.currentStaff.dailyReport[0]?.file) {
      return getFileNameFromPath(this.currentStaff.dailyReport[0].file);
    }
    return this.$t('dailyReport.chooseFileAttachment');
  }
  async save(): Promise<void> {
    const instance = await this.service.createOne(this.dailyReportPayload);
    try {
      await this.service.upload(instance.id, { file: this.file });
    } catch (e) {
      this.form.setErrors({ DailyReportFile: e.response.data.message });
      return;
    }
    this.dailyReportPayload.content = null;
    this.dailyReportPayload.emoticonId = null;
    this.file = null;
    this.form.reset();
    this.$emit('input', false);
  }
  async created() {
    await this.fetchEmoticons();
    if (this.currentStaff.dailyReport.length) {
      this.dailyReportPayload.content =
        this.currentStaff.dailyReport[0].content;
      this.dailyReportPayload.emoticonId =
        this.currentStaff.dailyReport[0].emoticonId;
    }
  }
}
